import { gql } from "@apollo/client";

export const GET_CONTRATOS_CONTROL_VISITAS = gql`
query GetControlVisitas($input: ControlVisitaFiltersInput!) {
    controlVisitas(input: $input){
        idEvaluacion
        idPaciente
        idProfesional
        estadoContrato
        estadoPaciente
        paciente
        pacienteNuevo
        idTipoModulo
        programa
        planCuidado
        profesional
        idFiguraProfesional
        figuraProfesional
        fase
        idFrecuencia
        frecuencia
        frecuenciaPlan
        fechaAsignacion
        cumplio
        colorCumplimiento
        visitasRealizadas
        visitasEstimadas
        visitasPendientesAutorizar
        visitasAJustificar
        visitasJustificadas
        cantidadCambioSonda
        cantidadUrgencias
        cantidadCapacitacion
        puedeModificar
        puedeGestionar
    }
}`;